/**
|--------------------------------------------------
| CourierExpress /orders | /orders/create-card
|--------------------------------------------------
*/
import {api} from 'api/setup';
import {IAddress} from 'types';
import {v4 as uuidv4} from 'uuid';

export function createNewOrderParamsCourierExpress(
  instructions: string,
  customer: CourierExpressSendNewOrderParams['customer'],
  userAdata: CourierExpressUserDataType,
  userBdata: CourierExpressUserDataType,
) {
  const params: CourierExpressSendNewOrderParams = {
    payment_for_self: true,
    cutlery_number: 0,
    contactless_delivery: false,
    promo_conditions_agree: true,
    order_for_another: false,
    app: 'website',
    items: [
      {
        product_id: 81467,
        product_quantity: 1,
        individual_items: [],
        instructions: instructions,
        added_automatically: false,
      },
    ],
    customer: customer,
    instructions: instructions,
    cart_uuid: uuidv4(),
    // courierExpress
    sender_address: formatAddressForOrder(userAdata),
    sender_phone: userAdata.phone,
    receiver_address: formatAddressForOrder(userBdata),
    receiver_phone: userBdata.phone,
  };

  return params;
}

export function createFormData(params: CourierExpressSendNewOrderParams, imgUrl?: string) {
  const formData: FormData = new FormData();
  // data must be {"key":value}
  formData.append('data', JSON.stringify(params));
  if (imgUrl) {
    formData.append('image', imgUrl);
  }
  return formData;
}

const formatAddressForOrder = (userData?: CourierExpressUserDataType) => {
  if (!userData) return '';
  const {addressInfo} = userData;
  if (!addressInfo) return '';
  let orderAddress: any = {
    number: addressInfo.number,
    street: addressInfo.street,
    latitude: addressInfo.latitude,
    longitude: addressInfo.longitude,
    city: addressInfo.city,
    geocoding_source: 'point.md',
  };
  if (addressInfo.is_private_building) {
    orderAddress.is_private_building = true;
    return orderAddress;
  }
  orderAddress = {
    ...orderAddress,
    ...addressInfo,
  };
  return orderAddress;
};

/**
 * CourierExpress TYPES
 */
export type CourierExpressUserDataType = {
  addressInfo: IAddress;
  phone: string;
  fromAutocomplete?: boolean;
};

export type CourierExpressSendNewOrderParams = {
  items: any[];
  instructions: string;
  cutlery_number: number;
  contactless_delivery: boolean;
  order_for_another: boolean;
  promo_conditions_agree: boolean;
  payment_for_self: boolean;
  customer: {
    name: string;
    phonenumber: string;
    email: string;
  };
  app: string;
  sender_address: PersonAdressType;
  sender_phone: string;
  receiver_address: PersonAdressType;
  receiver_phone: string;
  cart_uuid: string;
};

interface PersonAdressType {
  street: string;
  number: string;
  latitude: string;
  longitude: string;
  city: string;
  geocoding_source: string;
  is_private_building: boolean;
  apartment?: string;
  entrance?: number;
  floor?: number;
  entrance_code?: string;
}

export const getServerInfoConfig = (): Promise<{
  show_courier_express: boolean;
  maintenance_mode: boolean;
  cola_promo_active: boolean;
  cola_promo_threshold: number;
  maib_disabled: boolean;
  bpay_disabled: boolean;
  whatsapp_login: boolean;
}> => {
  // no need of locale since we dont have messages
  return api.get(`/server-info/config`);
};
